import { PropTypes } from "prop-types"
import classNames from "classnames"

import InputTelephone from "./InputTelephone"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function TelephoneField(props) {
  const {
    className,
    error,
    id,
    label,
    labelId,
    name,
    schema,
    onChange,
    isClearable = true,
    touched = false,
    ...rest
  } = props
  const handleChange = e => onChange(name, e.target.value || null)
  const handleClear = () => onChange(name, "")

  return (
    <Field className={classNames("oj-telephone-field", className)} touched={touched} error={error}>
      <Field.Label id={labelId} inputId={id} label={label} required={schema.required}>
        <Field.Input
          {...schema}
          {...rest}
          isClearable={isClearable}
          id={id}
          error={error}
          name={name}
          onClear={handleClear}
        >
          {innerProps => <InputTelephone {...innerProps} onChange={handleChange} />}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

TelephoneField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape(fieldSchemaPropTypes).isRequired,
  onChange: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  touched: PropTypes.bool
}

export default TelephoneField
